import { render } from "./DNSdialog.vue?vue&type=template&id=d4a8cee8&scoped=true"
import script from "./DNSdialog.vue?vue&type=script&lang=js"
export * from "./DNSdialog.vue?vue&type=script&lang=js"

import "./DNSdialog.vue?vue&type=style&index=0&id=d4a8cee8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d4a8cee8"

export default script